/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import Tooltip from "../../../../../components/Tooltip/Tooltip";
import { useDateTime } from "../../../../../shared";
import { useOverflow } from "../../../../../shared/hooks/useOverflow";
import { useStyles } from "../styles";
import { NewsDto } from "..";

interface ListedNewsItemContentProps {
  newsData: NewsDto;
}

const ListedNewsItemContent = ({ newsData }: ListedNewsItemContentProps) => {
  const { formatDateToEnString } = useDateTime();
  const { isVerticalOverflowing, measuredRef } = useOverflow([newsData.title]);
  const { textBox } = useStyles();

  return (
    <div css={css(textBox)} data-testid="news-content">
      <Typography
        variant="body4Medium"
        sx={{ color: colors.textPlaceholder, paddingBottom: "4px" }}
      >
        {formatDateToEnString(newsData.createdAt)}
      </Typography>

      <Tooltip
        title={newsData.title}
        disableHoverListener={!isVerticalOverflowing}
        size="medium"
        disableInteractive
      >
        <Typography
          variant="body3Medium"
          ref={measuredRef}
          css={css({
            color: colors.textDark,
            maxHeight: "32px",
            flex: 1,
            overflow: "hidden",
            minWidth: 0,
            textOverflow: "ellipsis",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
            wordBreak: "break-word",
            whiteSpace: "normal"
          })}
        >
          {newsData.title}
        </Typography>
      </Tooltip>
    </div>
  );
};

export default ListedNewsItemContent;
